import { render, staticRenderFns } from "./nformr-insta.vue?vue&type=template&id=6172f891"
import script from "./nformr-insta.vue?vue&type=script&lang=js"
export * from "./nformr-insta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports